module.exports = __webpack_public_path__ + "img/5corazon.5457f189.png";